import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.clients.views.FranchiseeClientDetailView.';
  public static readonly pleaseProvidePaymentProfile = `${Id.prefix}pleaseProvidePaymentProfile`;
  public static readonly provideStreetAddress = `${Id.prefix}provideStreetAddress`;
  public static readonly paymentProfile = `${Id.prefix}paymentProfile`;
  public static readonly clientDetails = `${Id.prefix}clientDetails`;
  public static readonly labelName = `${Id.prefix}labelName`;
  public static readonly phone = `${Id.prefix}phone`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly contactDetails = `${Id.prefix}contactDetails`;
  public static readonly clientAddress = `${Id.prefix}clientAddress`;
  public static readonly termsConditions = `${Id.prefix}termsConditions`;
}

export class LangFranchiseeClientDetailView {
  private constructor() {}
  public static pleaseProvidePaymentProfile(): string {
    return interpolate(Id.pleaseProvidePaymentProfile);
  }
  public static provideStreetAddress(): string {
    return interpolate(Id.provideStreetAddress);
  }
  public static paymentProfile(): string {
    return interpolate(Id.paymentProfile);
  }
  public static clientDetails(): string {
    return interpolate(Id.clientDetails);
  }
  public static labelName(): string {
    return interpolate(Id.labelName);
  }
  public static phone(): string {
    return interpolate(Id.phone);
  }
  public static status(): string {
    return interpolate(Id.status);
  }
  public static contactDetails(): string {
    return interpolate(Id.contactDetails);
  }
  public static clientAddress(): string {
    return interpolate(Id.clientAddress);
  }
  public static termsConditions(): string {
    return interpolate(Id.termsConditions);
  }
}

export class FranchiseeClientDetailViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.pleaseProvidePaymentProfile,
      "Please provide a {{glossary 'payment-profile'}}",
      'Validation error for missing payment profile'
    );
    register.add(
      Id.provideStreetAddress,
      'Please provide a Street Address',
      `Validation error for when a filled address is missing the street address`
    );

    register.add(Id.clientDetails, "{{glossary 'client'}} Details", 'Section header for client details');
    register.add(Id.labelName, 'Name', 'Label for client name');
    register.add(Id.phone, 'Phone', 'Label for client phone');
    register.add(Id.status, 'Status', 'Label for client status');
    register.add(Id.contactDetails, 'Contact Details', 'Section header for contact details');
    register.add(Id.clientAddress, 'Client Address', 'Section header for client address');
    register.add(Id.paymentProfile, "{{glossary 'payment-profile'}}", 'Label for payment profile');
    register.add(Id.termsConditions, "{{glossary 'terms-conditions'}}", 'Label for TaC');
  }
}
